import type {
  SingleAnswerQuestion,
  SingleAnswerQuestionOption,
} from '@feh/shared-ui';
import { createAction, props } from '@ngrx/store';

const prefix = '[HomebatteryQuestionnaire]';

export const submitQuestionnaireAnswer = createAction(
  `${prefix} Submit questionnaire answer`,
  props<{
    question: SingleAnswerQuestion;
    answer: SingleAnswerQuestionOption;
  }>()
);

export const leaveQuestionnaire = createAction(`${prefix} Leave questionnaire`);

export const loadNextQuestion = createAction(
  `${prefix} Load next question`,
  props<{ question: SingleAnswerQuestion }>()
);

export const loadPreviousQuestion = createAction(
  `${prefix} Load previous question`
);

export const answerMappingError = createAction(
  `${prefix} Error while mapping answer`
);
